<template>
  <div class="qmyx-container">
    <div class="totle-invited">
      <img
        src="https://assets.rurushishi.com/yq-rs-make/huafa/img/fazhanjjr_ic_renshu.png"
        class="totle-invited-icon"
        alt=""
      />
      <span>共{{ invitedAgentList.length }}人</span>
    </div>
    <div
      class="detail-list"
      v-for="(item, index) in invitedAgentList"
      :key="index"
    >
      <div class="detail-item">
        <div class="detail-item-row-1">
          <div class="invited-name">{{ item.agentName }}</div>
          <div class="invited-date">{{ item.createDate }}</div>
        </div>
        <div class="detail-item-row-2">
          <div class="invited-phone">{{ item.agentTel }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { getAgent } from "../../api";
import { getUserByTelOrIntroAgent } from "../api";
export default {
  computed: {
    ...mapState("qmyx", ["invitedAgentList"])
  },
  methods: {
    ...mapMutations("qmyx", ["saveInvitedAgentList"])
  },
  async activated() {
    if (!this.invitedAgentList || this.invitedAgentList.length <= 0) {
      let { agentLogin } = await getAgent();
      let resp = await getUserByTelOrIntroAgent(
        agentLogin.agentTel,
        agentLogin.id
      );
      resp = resp.filter(item => {
        return item.agentTel !== agentLogin.agentTel;
      });
      this.saveInvitedAgentList(resp);
    }
  }
};
</script>

<style lang="scss" scoped>
.qmyx-container {
  min-height: 100vh;
  padding-top: 0.4rem;
  & .totle-invited {
    width: 100%;
    height: 0.4rem;
    align-items: center;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    padding: 0 0.3rem;
    & .totle-invited-icon {
      display: block;
      width: 0.3rem;
      height: 0.3rem;
      margin-right: 0.08rem;
    }
    & span {
      display: block;
      color: #333;
      font-size: 0.28rem;
      height: 100%;
      line-height: 0.4rem;
    }
  }
  & .detail-list {
    margin-top: 0.32rem;
    & .detail-item {
      box-sizing: border-box;
      width: 100%;
      height: 1.32rem;
      padding: 0.24rem 0.3rem 0.26rem;
      font-size: 0.28rem;
      color: #999;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 200%;
        height: 0.02rem;
        background-color: #d8d8d8;
        transform: scale(0.5, 0.25);
        transform-origin: 0 0;
      }
      & .detail-item-row-1 {
        width: 100%;
        height: 0.4rem;
        line-height: 0.4rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        & .invited-name {
          color: #333;
        }
      }
      & .detail-item-row-2 {
        width: 100%;
        margin-top: 0.02rem;
        height: 0.4rem;
        line-height: 0.4rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
    }
  }
}
</style>
